import PropTypes from 'prop-types'
import React from 'react'
import { BaseApi } from 'Core/api/BaseApi'
import { connect } from 'react-redux'
import { setIsGroupPage } from '../src/modules/groups/actions'
import { getCurrentGroup } from '../src/modules/groups/selectors'
import { setIsCategoryPage, setCategoriesAndGroups } from '../src/modules/categories/actions'
import { getParentCategory, getCurrentSubCategory } from '../src/modules/categories/selectors'
import { CategoryHorizontalMenuMobile } from '../src/modules/categories/components'
import { deepCopy } from '../src/utils'
import { adsTypes, globalOptions } from '../src/core/constants'
import { fetchCitiesByCountryWithinRegions } from '../src/modules/geoObjects/cities/actions'
import { fetchAds, setSavedSearchBtnEnabled } from '../src/modules/ads/list/actions'
import { AdsList } from '../src/modules/ads/list/components'
import { PanelMobile } from '../src/modules/ads/list/components/PanelMobile'
import { SearchPagination } from '../src/modules/ads/pagination/components'
import { UserAdsFilter } from '../src/modules/ads/filter/components'
import { getParsedFilterValues } from '../src/modules/ads/filter/functions'
import { AdsHeaderExtended } from '../src/modules/ads/filter/Container'
import { Page } from '../src/ui'
import { fetchInfo, setInfo } from '../src/modules/users/detail/actions'
import { getInfo } from '../src/modules/users/detail/selectors'
import { fetchPageMetaTags } from '../src/modules/common/actions'
import initialState from '../src/modules/redux/initialState'
import config from '../src/config/config.yaml'

class OglasiSearchPage extends React.Component {
  static async getInitialProps ({store, req, query, isServer}) {
    console.log('query', query)
    let state = store.getState()
    const categoryInUrl = query.category
    const parentCategoryInUrl = query.parentCategory

    const isMobileDevice = store.getState().common.isMobileDevice

    const limit = isMobileDevice
      ? globalOptions.adsCountPerPageWithoutSidebarMobile
      : globalOptions.adsCountPerPageWithoutSidebar

    const type = adsTypes.all
    const status = 'Published'
    let userType = query.userType
    if (isNaN(Number(query.userType))) {
      const findUserType = state.common.selectableUserTypes.find(item => item.seo === query.userType)
      if (findUserType) userType = findUserType.id
    }
    let page = 1
    let isUserSearch = false
    if (req) {
      if (req.query.pageNumber) {
        page = Number(req.query.pageNumber)
      }
    } else {
      if (query.pageNumber) {
        page = query.pageNumber
      }
    }

    let category, isGroupPage, isCategoryPage
    let adsRequestOptions = {page, type, limit, status}

    if (query.username) {
      await store.dispatch(fetchInfo({ username: query.username }))
      isUserSearch = true
    } else {
      store.dispatch(setInfo(null))
    }
    if (isUserSearch) {
      const userInfo = getInfo(store.getState())
      if (userInfo && userInfo.id) {
        adsRequestOptions.adUser = userInfo.id
      }

      const isMobileDevice = store.getState().common.isMobileDevice
      adsRequestOptions.limit = isMobileDevice ? globalOptions.adsCountPerPageMobile : globalOptions.adsCountPerPage
    }

    await store.dispatch(setCategoriesAndGroups(parentCategoryInUrl, categoryInUrl))
    if (!isMobileDevice) await store.dispatch(fetchCitiesByCountryWithinRegions(globalOptions.MontenegroId))

    state = store.getState()

    const currentSubcategory = getCurrentSubCategory(state)
    const currentParentCategory = getParentCategory(state)
    const currentGroup = getCurrentGroup(state)

    if (currentSubcategory) {
      category = currentSubcategory
      adsRequestOptions.category = category.id
      isGroupPage = false
      isCategoryPage = true
      await store.dispatch(fetchPageMetaTags({ category: currentSubcategory.id }))
    } else if (currentParentCategory && !categoryInUrl) {
      category = currentParentCategory
      adsRequestOptions.parentCategory = category.id
      isGroupPage = false
      isCategoryPage = true
      await store.dispatch(fetchPageMetaTags({ category: currentParentCategory.id }))
    } else {
      category = currentGroup
      if (category) {
        adsRequestOptions.group = category.id
        await store.dispatch(fetchPageMetaTags({ group: currentGroup.id }))
      }

      isGroupPage = true
      isCategoryPage = false
    }

    if (userType && !adsRequestOptions.adUser) adsRequestOptions.userType = userType

    const paginationParams = {
      ...store.getState().ads.pagination.params,
      currentPage: Number(page),
      adsType: type
    }

    const formStyle = isServer ? req.query.formStyle : query.formStyle

    const pageMetaTags = store.getState().common.pageMetaTagsSingle

    const possibleValues = (query['0'] || '').split('/')
    let pageUrlItems = []

    if (Array.isArray(possibleValues) && possibleValues.length && (currentSubcategory || currentParentCategory)) {
      const pageUrlItemsResponse = await BaseApi.post(`/v2/misc/getSearchPageUrlItems`, {
        items: possibleValues,
        category: currentSubcategory ? currentSubcategory.id : currentParentCategory.id,
        locale: 'ME'
      })

      if (pageUrlItemsResponse?.body?.items) pageUrlItems = pageUrlItemsResponse.body.items
    }

    const parsedFilterValues = getParsedFilterValues({
      filterValues: query,
      pageMetaTags,
      pageUrlItems,
      possibleValues: (query['0'] || '').split('/')
    })

    if (parsedFilterValues.fullText) {
      const { category, parentCategory, group, ...rest } = adsRequestOptions

      adsRequestOptions = rest
    }

    store.dispatch(setIsGroupPage(isGroupPage))
    store.dispatch(setIsCategoryPage(isCategoryPage))

    if (!parsedFilterValues.sortBy) parsedFilterValues.sortBy = 'dateDesc'

    await store.dispatch(fetchAds({ ...adsRequestOptions, ...parsedFilterValues }, paginationParams))

    store.dispatch(setSavedSearchBtnEnabled(true))

    const filterValues = { ...parsedFilterValues }
    if (adsRequestOptions.userType) filterValues.userType = adsRequestOptions.userType

    return {
      title: category && category.title
        ? `${config.pages.category.title} - ${category.title} | ${config.pages.defaultTitle}`
        : `${config.pages.category.title} | ${config.pages.defaultTitle}`,
      isPageExists: true,
      isUserSearch,
      filterValues,
      isMobileDevice,
      formStyle,
      pageUrlItems,
      layoutStyle: isUserSearch ? 'default' : 'no-sidebar',
      state: OglasiSearchPage.getPageState(store, true)
    }
  }

  static getPageState (store) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.detail = currentState.user.detail

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = false
      state.common.userTypes = currentState.common.userTypes
      state.common.selectableUserTypes = currentState.common.selectableUserTypes
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups = currentState.groups

      state.categories = currentState.categories

      state.ads.list = currentState.ads.list
      state.ads.pagination = currentState.ads.pagination
      state.ads.brands = currentState.ads.brands
      state.ads.products = currentState.ads.products
      state.ads.equipment = currentState.ads.equipment
      state.ads.services = currentState.ads.services
      state.ads.serviceTypes = currentState.ads.serviceTypes

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.form = currentState.form

      state.cart = currentState.cart
      state.orders = currentState.orders
    }
    return state
  }

  render () {
    const { isUserSearch, filterValues, formStyle, isMobileDevice, pageUrlItems } = this.props
    return (
      <Page className={!isUserSearch ? 'main-content-extended' : ''}>
        {isUserSearch
          ? (
            <UserAdsFilter
              filterValues={filterValues}
              formStyle={formStyle}
            />
          ) : !isMobileDevice
            ? (
              <AdsHeaderExtended
                filterValues={filterValues}
                formStyle={formStyle}
              />
            ) : <CategoryHorizontalMenuMobile />
        }
        <AdsList
          noAdsMessage={config.pages.category.noAdsMessage}
          isSearchPage
          filterValues={filterValues}
          formStyle={formStyle}
          isUserSearch={isUserSearch}
          pageUrlItems={pageUrlItems}
        />
        <SearchPagination isUserSearch={isUserSearch} filterValues={filterValues} formStyle={formStyle} />
        {isMobileDevice ? <PanelMobile filterValues={filterValues} /> : null}
      </Page>
    )
  }
}

OglasiSearchPage.propTypes = {
  isUserSearch: PropTypes.bool.isRequired,
  filterValues: PropTypes.object.isRequired,
  formStyle: PropTypes.string.isRequired,
  isMobileDevice: PropTypes.string.isRequired,
  pageUrlItems: PropTypes.object
}

OglasiSearchPage.defaultProps = {
  isUserSearch: false
}

export default OglasiSearchPage
